module.exports = __webpack_public_path__ + "static/creativeHero-339b738a6dee9b7ef409b75686af40ae.png";